// --- React & Redux
import React from "react";
// --- Actions & Hooks
import { usePermissions } from "../../utils/permissions";
import { useHomeDashboardData } from "./hooks/useHomeDashboardData";
// --- Components
import { PMXCatalogs } from "./components/PMXCatalogs";
import { TwoRowsLayout } from "./layout/two-row";
import { WelcomeBanner } from "./components/Welcome";
import { LicensingJobs } from "./components/LicensingJobs";

export const HomePage = () => {
  const { isDigitalStoresUser, isTapUser } = usePermissions();
  const { catalogs, catalogsLoading, licensingJobsData, jobsLoading } =
    useHomeDashboardData({ isTapUser });

  return (
    <>
      <TwoRowsLayout twoColumn>
        <main data-position="top">
          <WelcomeBanner />
        </main>
        {!isDigitalStoresUser && (
          <main data-position="bottom-left">
            <PMXCatalogs catalogs={catalogs} isLoading={catalogsLoading} />
          </main>
        )}
        {!isDigitalStoresUser && (
          <main data-position="bottom-right">
            <LicensingJobs data={licensingJobsData} isLoading={jobsLoading} />
          </main>
        )}
      </TwoRowsLayout>
    </>
  );
};
